.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  height: var(--input-h);
  padding: 0 var(--space-5);
  border-radius: var(--radius-sm);
  font-size: var(--fs-ui);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: background-color var(--dur-fast) var(--ease);
}

.btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.sm {
  height: 22px;
  padding: 0 var(--space-4);
  font-size: var(--fs-sm);
}

.solid {
  background: var(--accent);
  color: var(--text-on-accent);
}
.solid:hover:not(:disabled) {
  background: var(--accent-hover);
}
.solid:active:not(:disabled) {
  background: var(--accent-active);
}

.ghost {
  background: transparent;
  color: var(--text-secondary);
  box-shadow: inset 0 0 0 1px var(--border-strong);
}
.ghost:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
}
.ghost:active:not(:disabled) {
  background: var(--surface-active);
}

.subtle {
  background: transparent;
  color: var(--text-secondary);
}
.subtle:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.danger {
  background: var(--danger);
  color: hsl(0 60% 8%);
}
.danger:hover:not(:disabled) {
  background: hsl(0 68% 64%);
}
